export const authRoutes = [
  "/",
  "*",
  "/area-personale/corsi",
  "/area-personale/corso",
  "/area-personale/classi",
  "/area-personale/classe",
  "/area-personale/ticket",
  "/area-personale/voucher",
  "/area-personale/calendario/esami",
  "/area-personale/calendario/lezioni",
  "/gestione-corsi",
  "/profilo",
  "/crea-corso",
  "/aggiungi-contenuti",
  "/configura-lezioni",
  "/configura-esami",
  "/configura-argomenti",
  "/registro-presenze",
  "/gestione-classi-utenti",
  "/gestione-utenti",
  "/gestione-ticket",
  "/gestione-agenzie",
  "/gestione-classi",
  "/gestione-sedi",
  "/gestione-certificazioni",
  "/gestione-contabilizzazioni",
  "/contabilizzazioni",
  "/blacklist-utenti",
  "/gestione-risultati-esame",
  "/assegna-corsi",
  "/gestione-corsi-utenti",
  "/checkout",
  "/return-checkout",
  "/area-personale/invita-amico"
];
